import React from "react";
import {useUserManager} from "./UserManagerContext";
import {HOME_ROUTE} from "../../components/router/routes";

export function AuthRedirectCallback() {
  const userManager = useUserManager();
  userManager.signinRedirectCallback().then(user => {
    const originHref: string = user?.state?.originHref || HOME_ROUTE.path;
    window.location.href = originHref;
  });
  return <></>;
}

export function AuthSilentRedirectCallback() {
  const userManager = useUserManager();
  userManager.signinSilentCallback().then(user => {
    // console.log(`AuthSilentRedirectCallback, authentication successful, user: ` + user);
    if (!user) {
      console.log('AuthSilentRedirectCallback: No user found');
      userManager.clearStaleState().then();
      // userManager.signinRedirect().then();
    }
  });
  return <></>;
}
